import List from '@editorjs/list'
import Embed from '@editorjs/embed'
import Table from '@editorjs/table'
import Quote from '@editorjs/quote'
import CodeTool from '@editorjs/code'
import Header from '@editorjs/header'
import Marker from '@editorjs/marker'
import Warning from '@editorjs/warning'
import Delimiter from '@editorjs/delimiter'
import Checklist from '@editorjs/checklist'
import InlineCode from '@editorjs/inline-code'
import Slider from '../plugins/editorjs/slider/slider.js'
import MediaLibraryImage from '../plugins/editorjs/medialibrary-image/medialibrary-image.js'

export default {
    get(component) {
        return {
            header: {
                class: Header,
                config: {
                    placeholder: 'Enter a header',
                    levels: [2, 3, 4],
                    defaultLevel: 3,
                }
            },
            list: {
                class: List,
                inlineToolbar: true
            },
            code: {
                class: CodeTool
            },
            embed: {
                class: Embed,
                config: {
                    services: {
                        youtube: true,
                    }
                }
            },
            table: {
                class: Table,
                inlineToolbar: true,
                config: {
                    rows: 2,
                    cols: 3,
                },
            },
            checklist: {
                class: Checklist,
            },
            marker: {
                class: Marker,
                shortcut: 'CMD+SHIFT+M',
            },
            warning: {
                class: Warning,
                inlineToolbar: true,
                shortcut: 'CMD+SHIFT+W',
                config: {
                    titlePlaceholder: 'Title',
                    messagePlaceholder: 'Message',
                },
            },
            quote: {
                class: Quote,
                inlineToolbar: true,
                shortcut: 'CMD+SHIFT+O',
                config: {
                    quotePlaceholder: 'Enter a quote',
                    captionPlaceholder: 'Quote\'s author',
                },
            },
            inlineCode: {
                class: InlineCode,
                shortcut: 'CMD+SHIFT+M',
            },
            delimiter: Delimiter,
            image: {
                class: MediaLibraryImage,
                config: {
                    showCallback: component.showLibrary,
                    selectCallback: component.setSelectCallback
                }
            },
            slider: {
                class: Slider,
                config: {}
            }
        }
    }
}
